import { create } from 'zustand';
import { syncEngine, type SyncEngineStatus } from '../lib/sync-engine';

interface SyncState extends SyncEngineStatus {
  start: (userId: string) => Promise<void>;
  stop: () => void;
  syncNow: () => Promise<void>;
}

let unsubscribeEngine: (() => void) | null = null;

export const useSyncStore = create<SyncState>((set) => ({
  online: typeof navigator !== 'undefined' ? navigator.onLine : true,
  syncing: false,
  pendingCount: 0,
  lastSyncAt: null,
  lastError: null,
  wsStatus: 'idle',

  start: async (userId: string) => {
    unsubscribeEngine?.();
    unsubscribeEngine = syncEngine.subscribe((status: SyncEngineStatus) => {
      set(status);
    });
    await syncEngine.start(userId);
    set(syncEngine.getStatus());
  },

  stop: () => {
    unsubscribeEngine?.();
    unsubscribeEngine = null;
    syncEngine.stop();
    set({
      online: typeof navigator !== 'undefined' ? navigator.onLine : true,
      syncing: false,
      pendingCount: 0,
      lastSyncAt: null,
      lastError: null,
      wsStatus: 'idle',
    });
  },

  syncNow: async () => {
    await syncEngine.syncNow();
    set(syncEngine.getStatus());
    await syncEngine.refreshPendingCount();
    set(syncEngine.getStatus());
  },
}));
